function getSendViaLocation(): string {
  if (typeof window === "undefined") {
    return ""
  }
  return `${window.location.host}${window.location.pathname}`
}

const SEND_VIA_SUFFIX = /\s*Send via .+$/i

/**
 * Appends the current page host+path to a support/feedback message
 * so backend operators can tell which site/page it came from.
 * Uses host+pathname (no protocol), single line — passes FLD_MESSAGE validation.
 * Safe to call multiple times — won't double-append.
 */
export function appendSendVia(
  message: string,
  location: string = getSendViaLocation(),
): string {
  const text = message ?? ""
  if (SEND_VIA_SUFFIX.test(text)) {
    return text
  }
  const base = text.trimEnd()
  return base ? `${base} Send via ${location}` : `Send via ${location}`
}
